var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-button"},[(_vm.showBackToTop)?_c('SfButton',{on:{"click":_vm.scrollToTop}},[_c('SfIcon',{attrs:{"icon":"chevron_up","size":"xxs","color":"white","viewBox":"0 0 24 24","coverage":1}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }